import { render, staticRenderFns } from "./verEstadisticas.vue?vue&type=template&id=1c7ddcb2"
import script from "./verEstadisticas.vue?vue&type=script&lang=js"
export * from "./verEstadisticas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports